<div class="container container_small">
  <H1>Transfer Box</H1>

  <div>
    <div class="form-group">
      <label>Enter Box Number:</label>
      <input class="form-control" name="BoxNumber" type="text" [(ngModel)]="BoxNumber" required
        placeholder="Enter Box Number" maxlength="30" (ngModelChange)="BoxNameChanged()" />

      <label style="margin-top: 20px;">Exsisting Boxes:</label>
      <select class="selectpicker form-control" multiple="true"
        style="padding-bottom: 0px;margin-left: auto;margin-right: auto;" [(ngModel)]="PossibleBox"
        (change)="PossibleBoxChanged()">
        <option *ngFor="let item of PossibleBoxNumbers; let i =index" value={{item}}>{{item}}
        </option>
      </select>
    </div>


    <div class="form-group">
      <label>New Branch:</label>
      <div class="input-group mb-3">
        <select class="form-control" name="Branch" type="text" [(ngModel)]="Branch" required placeholder="Enter Branch">
          <option *ngFor="let Branch of Branchs; let i =index" value={{Branch}}>{{Branch}}
          </option>
        </select>
      </div>
    </div>

  </div>

  <div class="form-group form-button-div">

    <div style="float: left;margin-right: 20px;margin-left:20px;">
      <button class="btn btn-warning btn-lg btn-block" type="submit" (click)="Reset()">Reset</button>
    </div>

    <div style="float: right;margin-left:20px;">
      <button class="btn btn-success btn-lg btn-block" type="submit" [disabled]="!BoxNumber ||!Branch"
        (click)="Save()">Save</button>
    </div>

  </div>

</div>



<!--Error popup-->
<div style="float: right;margin-left:20px;">
  <button class="btn btn-success btn-lg btn-block" id="ErrorButton" (click)="open(content)" style="display: none;">
  </button>
</div>
<ng-template #content let-modal ID="Errormessage">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">
      {{PopupTitle}}
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">

      <span aria-hidden="true">
        ×
      </span>
    </button>
  </div>
  <div class="modal-body">
    <form>
      <div class="form-group">
        <label for="dateOfBirth">
          {{DisplayErrormessage}}
        </label>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success btn-lg btn-block" (click)="modal.close('Save click')">
      Done
    </button>
  </div>
</ng-template>



<ng-template #content2 let-modal ID="ConfirmReset">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">
      {{PopupTitle}}
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">

      <span aria-hidden="true">
        X
      </span>
    </button>
  </div>
  <div class="modal-body">
    <form>
      <div class="form-group">
        <label for="dateOfBirth">
          {{DisplayErrormessage}}
        </label>

        <div class="form-group">
          <input class="form-control" name="ConfirmReset" type="text" [(ngModel)]="ConfirmReset" required placeholder=""
            maxlength="30" />
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success btn-lg btn-block" (click)="modal.close('Save click')">
      Done
    </button>

    <button type="button" class="btn btn-warning btn-lg btn-block" (click)="modal.close('Cancel')">
      Cancel
    </button>
  </div>
</ng-template>
